// The live App Store listing (ASC app id). One source for the app's update
// gate (components/UpdateGate.js) and the web app's "Get the iOS app" links.
const APP_STORE_ID = "6751124958";
export const APP_STORE_WEB_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;
export const APP_STORE_APP_URL = `itms-apps://apps.apple.com/app/id${APP_STORE_ID}`;
